import { convertTeeSetSideToRatingType } from "../../../shared/helpers/model-helper";

export const convertScoreToRoundSetup = (score) => ({
  nrOfHoles: score.number_of_holes,
  tees: {
    RatingType: convertTeeSetSideToRatingType(score.tee_set_side),
    TeeSetRatingId: Number(score.tee_set_id),
  },
});
